export default {
  title: 'Статистика рынка недвижимости в провинции Анталья',
  tabs: {
    sales: 'Продажи недвижимости',
    permits: 'Разрешения на строительство'
  }
}
